// Editor view modes, ranked simplest -> most powerful. See DND_EMAIL_MODE_SPEC.md.
//   email    — most guided/minimal (a tier below simple)
//   simple   — curated "Quick Styles" panels + reduced block set + no CSS-class UI
//   advanced — full StyleManager + all blocks
//
// The mode is stored as the user's server-side dnd-mode (redux `userDndMode`).
// Prefer these helpers over literal string comparisons so a new tier ('email')
// inherits the right behaviour at every gate.
export const EDITOR_MODES = {
  EMAIL: 'email',
  SIMPLE: 'simple',
  ADVANCED: 'advanced',
};

const RANK = { email: 0, simple: 1, advanced: 2 };

// True only for the full-power 'advanced' mode.
export const isAdvancedMode = (mode) =>
  RANK[mode] >= RANK[EDITOR_MODES.ADVANCED];

// True for any GUIDED mode ('simple' or 'email') — i.e. not advanced, and a known mode.
// Use where the code previously checked `mode === 'simple'` but 'email' must inherit the
// same (simpler) treatment. Unknown/undefined modes return false, matching the old `=== 'simple'`.
export const isSimpleOrSimpler = (mode) =>
  mode in RANK && RANK[mode] <= RANK[EDITOR_MODES.SIMPLE];

export const isEmailMode = (mode) => mode === EDITOR_MODES.EMAIL;
